import { Trans, useTranslation } from 'react-i18next';
import { MARKET } from '@/common/constants/markets';
import { TInsurancePerson } from '@/common/integrations/menhir/employee/insurance/insurance.types';
import { INTL_MONTH_DAY_FORMAT, intlFormat } from '@/common/utils/date';
import { useMarket } from '@/web/hooks/useMarket';
import { Flex, GenericModal, Text } from '@coverflex-tech/hypernova';
import { css } from './InsuranceNotIncludedFamilyMembersModal.css';

export const InsuranceNotIncludedFamilyMembersModal = ({
  familyMembers,
  enrolEndDate,
  onClose,
  planName,
  onAction,
}: TInsuranceNotIncludedFamilyMembersModalProps) => {
  const { t } = useTranslation();
  const formattedEnrolEndDate = intlFormat(enrolEndDate, INTL_MONTH_DAY_FORMAT);
  const { slug } = useMarket();

  return (
    <>
      <GenericModal
        title={t('dashboard.insurance.upgrade_plan_confirmation_modal.title', {
          plan: planName,
        })}
        content={
          <Flex flexDirection="column" gap="md">
            <Trans
              parent={Text}
              color="neutral20"
              bold
              i18nKey="dashboard.insurance.upgrade_plan_confirmation_modal.added_family.no_included_family"
            />
            <Flex justifyContent="center">
              <ul className={css.memberList}>
                {familyMembers
                  .filter((member) => !member.included)
                  .map((member) => (
                    <Flex key={member.id}>
                      <li className={css.memberName}>{member.shortName}</li>
                    </Flex>
                  ))}
              </ul>
            </Flex>
            {slug !== MARKET.ES && (
              <Trans
                parent={Text}
                color="neutral20"
                bold
                i18nKey="dashboard.insurance.upgrade_plan_confirmation_modal.added_family.no_included_family.description"
                values={{ date: formattedEnrolEndDate }}
              />
            )}
          </Flex>
        }
        primaryAction={{
          children: (
            <Trans i18nKey="dashboard.insurance.upgrade_plan_confirmation_modal.confirm_label" />
          ),
          onClick: () => onAction?.(),
        }}
        secondaryAction={{
          children: <Trans i18nKey="general.navigation.cancel" />,
          onClick: () => onClose?.(),
        }}
      />
    </>
  );
};

export type TInsuranceNotIncludedFamilyMembersModalProps = {
  familyMembers: TInsurancePerson[];
  onAction?: Function;
  onClose?: Function;
  planName?: string;
  enrolEndDate?: string;
};
